import { __assign, __read } from "tslib";
import screenTransitions from './screenTransitions';
var LEFT_RIGHT_EASING = [0.145, 0.82, 0.34, 1.015];
var UP_DOWN_EASING = [0.272, 0.224, 0.265, 0.975];
var FADE_DURATION = 400;
var POP_DURATION = 300;
var LEFT_RIGHT_DURATION = 350;
var UP_DOWN_DURATION = 300;
var animations = {
    fade: function () {
        return {
            enter: {
                animation: {
                    opacity: [1, 0],
                },
                duration: FADE_DURATION,
            },
            leave: {
                animation: {
                    opacity: [0, 1],
                },
                duration: FADE_DURATION,
                display: 'none',
            },
        };
    },
    // pushleft in the editor!
    pushright: function (_a) {
        var width = _a.width;
        var translateX = width + "px";
        return {
            enter: {
                animation: {
                    translateX: [0, translateX],
                    opacity: [1, 1],
                },
                easing: LEFT_RIGHT_EASING,
                duration: LEFT_RIGHT_DURATION,
            },
            leave: {
                animation: {
                    translateX: [translateX, 0],
                },
                easing: LEFT_RIGHT_EASING,
                duration: LEFT_RIGHT_DURATION,
            },
        };
    },
    // pushright in the editor!
    pushleft: function (_a) {
        var width = _a.width;
        var translateX = "-" + width + "px";
        return {
            enter: {
                animation: {
                    translateX: [0, translateX],
                    opacity: [1, 1],
                },
                easing: LEFT_RIGHT_EASING,
                duration: LEFT_RIGHT_DURATION,
            },
            leave: {
                animation: {
                    translateX: translateX,
                },
                easing: LEFT_RIGHT_EASING,
                duration: LEFT_RIGHT_DURATION,
            },
        };
    },
    slideup: function (_a) {
        var height = _a.height;
        var translateY = height + "px";
        return {
            enter: {
                animation: {
                    translateY: [0, translateY],
                    opacity: [1, 1],
                },
                easing: UP_DOWN_EASING,
                duration: UP_DOWN_DURATION,
            },
            leave: {
                animation: {
                    translateY: translateY,
                },
                easing: UP_DOWN_EASING,
                duration: UP_DOWN_DURATION,
            },
        };
    },
    slidedown: function (_a) {
        var height = _a.height;
        var translateY = "-" + height;
        return {
            enter: {
                animation: {
                    translateY: [0, translateY],
                },
                easing: UP_DOWN_EASING,
                duration: UP_DOWN_DURATION,
            },
            leave: {
                animation: {
                    translateY: translateY,
                },
                easing: UP_DOWN_EASING,
                duration: UP_DOWN_DURATION,
            },
        };
    },
    pop: function () {
        return {
            enter: {
                animation: {
                    scale: [1, 0],
                    opacity: [1, 0],
                },
                duration: POP_DURATION,
            },
            leave: {
                animation: {
                    scale: [0, 1],
                    opacity: [0, 1],
                },
                duration: POP_DURATION,
            },
        };
    },
    flip: function () {
        return copyScreenAnimations(screenTransitions.flip.currentScreen, screenTransitions.flip.previousScreen);
    },
    flow: function () {
        return copyScreenAnimations(screenTransitions.flow.currentScreen, screenTransitions.flowReverse.previousScreen);
    },
    slidefade: function () {
        return copyScreenAnimations(screenTransitions.slidefade.currentScreen, screenTransitions.slidefadeReverse.previousScreen);
    },
    slidefadeReverse: function () {
        return copyScreenAnimations(screenTransitions.slidefadeReverse.currentScreen, screenTransitions.slidefade.previousScreen);
    },
    flowReverse: function () {
        return copyScreenAnimations(screenTransitions.flowReverse.currentScreen, screenTransitions.flow.previousScreen);
    },
};
animations['slide-left'] = animations.pushleft;
animations.slide = animations.pushright;
export default function getAnimation(transition, renderedScreenDimensions) {
    var transitionsFactory = animations[transition];
    if (!transitionsFactory) {
        return undefined;
    }
    return transitionsFactory(renderedScreenDimensions);
}
function copyScreenAnimations(enterAnimation, leaveAnimation) {
    var _a;
    var _b = __read(enterAnimation, 2), animation = _b[0], options = _b[1];
    var enter = __assign({ animation: animation }, options);
    _a = __read(leaveAnimation, 2), animation = _a[0], options = _a[1];
    var leave = __assign({ animation: animation }, options);
    return { enter: enter, leave: leave };
}
export function getTransitionForTransitionToSameScreen(transition) {
    switch (transition) {
        case 'fade':
        case 'pop':
        case 'flip':
            return transition;
        case 'flow':
            return 'flowReverse';
        case 'flowReverse':
            return 'flow';
        case 'slidefade':
            return 'slidefadeReverse';
        case 'slidefadeReverse':
            return 'slidefade';
        case 'pushleft':
            return 'pushright';
        case 'pushright':
            return 'pushleft';
        case 'slide-left':
            return 'slide';
        case 'slide':
            return 'slide-left';
        case 'slideup':
            return 'slidedown';
        case 'slidedown':
            return 'slideup';
        default:
            throw new Error("Transition '" + transition + "' is not a valid overlay transition");
    }
}
